import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'info-card',
    templateUrl: './info-card.component.html',
    styleUrls: ['./info-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InfoCardComponent {
    @Input() title: string;
    @Input() icon: string;
    @Input() infoCardColor: string = 'info-card-blue';
    @Input() isHollow: boolean = true;

    constructor() {}
}
